export const EMAIL_VALUE_RE = /^[\w\-.]+@([\w-]+\.)+[\w-]{2,5}$/;
export const TEL_VALUE_RE = /^[\d()+-]{6,25}$/;
export const USERNAME_VALUE_RE = /^[\w\-.]{7,30}$/;
